import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'react-admin';
import { push as reduxPush } from 'react-router-redux';
import ContentCreate from '@material-ui/icons/Create';

class EditButton extends Component {
  handleClick = () => {
    const {
      push,
      basePath,
      record,
      path,
    } = this.props;
    const split = path.split('/');
    let tabNumber = split.length > 3 ? Number.parseInt(split.pop(), 10) : NaN;
    if (tabNumber > 5) { // TODO if order tab changes position change this one too
      tabNumber = '';
    }
    push(`${basePath}/${record.id}${!Number.isNaN(tabNumber) ? `/${tabNumber}` : ''}`);
  }

  render() {
    return (
      <Button label="Edit" onClick={this.handleClick}>
        <ContentCreate />
      </Button>
    );
  }
}

EditButton.propTypes = {
  push: PropTypes.func,
  record: PropTypes.object, // eslint-disable-line
};

EditButton.defaultProps = {
  push: () => {},
  record: {},
};

export default connect(null, {
  push: reduxPush,
})(EditButton);



// WEBPACK FOOTER //
// ./src/components/OfferOrder/EditButton.js